__turbopack_context__.v({
  "brandchip": "z9JmdG_brandchip",
});
